module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Southampton.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Southampton.png
// module id = 2193
// module chunks = 4